/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if (this.collection_layout == 'slider') {
      this.createSlider('.slider-gallery--desktop');
    }

    if (this.collection_layout_mobile == 'slider') {
      this.createSlider('.slider-gallery--mobile');
    }
  },
  createSlider: function(el) {
    const slider = $(el);

    $(slider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: this.products_limit > this.products_per ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape
    });

    $(slider).on('settle.flickity', () => $(slider).flickity('resize'));
  },
  updateFilteredCollection: function(filterURL, $section) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {

      },
      success: function(data) {
      },
      error: function(x, t, m) {
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    }).then(function(data){

      // Fix Gruppe B, Punkt "Selektor-Scope": nur die Section beruecksichtigen, in der geklickt wurde
      // (verhindert, dass ein Klick auf Landingpages mit mehreren Featured-Collection-Sections alle leert)
      const $collectionMain = $section.find('.filteredCollection');

      // Fix Gruppe B, Punkt 9: Slider VOR dem DOM-Wechsel zerstoeren, nicht danach
      window.PXUTheme.jsFeaturedCollection.unload($collectionMain);

      // Check for products
      const filteredData = $(data).find('.filteredCollection');

      if (filteredData.length) {
        // Fix Gruppe B, Punkt 10: Inhalt ersetzen statt anhaengen (verhindert verschachtelte .filteredCollection)
        $collectionMain.html(filteredData.html());
      }

      // Fix Gruppe B, Punkt 12: lazySizes erneut ueber das neu eingefuegte DOM laufen lassen,
      // bevor Flickity die Hoehe misst (behebt zugleich den Mega-Menue-Bug an anderer Stelle)
      if (window.lazySizes && lazySizes.loader && typeof lazySizes.loader.checkElems === 'function') {
        lazySizes.loader.checkElems();
      } else if (window.lazySizes && typeof lazySizes.checkElems === 'function') {
        lazySizes.checkElems();
      }

      // Fix Gruppe B, Punkt 11: Slider nur bauen, wenn das Layout tatsaechlich einen Slider gerendert hat
      const $desktopSlider = $collectionMain.find('.slider-gallery--desktop');
      if ($desktopSlider.length) {
        window.PXUTheme.jsFeaturedCollection.createSlider($desktopSlider);
      }

      const $mobileSlider = $collectionMain.find('.slider-gallery--mobile');
      if ($mobileSlider.length) {
        window.PXUTheme.jsFeaturedCollection.createSlider($mobileSlider);
      }
    });
  },
  unload: function($section) {
    const $slider = $section.find('.flickity-enabled');
    if ($slider.length) {
      $slider.flickity('destroy');
    }
  }
}

/******/ })()
;
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.custom_filter_collection').forEach(function(el) {
    el.addEventListener('click', function() {

      // Fix Gruppe B, Punkt "Selektor-Scope": Kontext auf die eigene Section begrenzen,
      // damit auf Landingpages mit mehreren Featured-Collection-Sections nur die
      // angeklickte Section aktualisiert wird
      const $button = $(this);
      const $section = $button.closest('section');

      $section.find('.custom_filter_collection').removeClass('active');
      $button.addClass('active');

      let collectionHandle = this.dataset.handle;
      let collectionUrl = '/collections/' + collectionHandle + '?view=new_slyder';

      // Punkt 19 (2026-09-16): zweimal versucht, zweimal zurueckgesetzt. Section-Rendering-API
      // (section_id=...) funktioniert hier grundsaetzlich NICHT: Dieser Button/diese Section
      // (sections/index__featured-collection.liquid, auf der Startseite instanziert) zeigt IMMER eine
      // fest in den Section-Settings hinterlegte Collection ("alle-produkte"), unabhaengig von der
      // aufgerufenen URL - der Klick-Handler kann also nur ueber den vollen Seiten-Fetch der Zielseite
      // (collections/<handle>?view=new_slyder, Template collection.new_slyder.json mit der ANDEREN
      // Section sections/index__featured-collection-filter.liquid, die die Collection korrekt aus der
      // Route liest) an die tatsaechlich gefilterten Produkte kommen. Ein Section-Rendering-API-Aufruf
      // mit section_id der aktuellen (Start-)Seite liefert immer wieder dieselbe fixe Collection zurueck,
      // ein Aufruf mit der ID der Zielseite waere nur mit fest codierter, seiten-uebergreifender
      // Section-ID moeglich (fragil, siehe Punkt 15). Deshalb bewusst bei der vollen Seiten-Antwort
      // belassen - funktional korrekt und bereits durch Gruppe B verifiziert.
      window.PXUTheme.jsFeaturedCollection.updateFilteredCollection(collectionUrl, $section);

    });
  });
});
